import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { AppNotification, JoiAppInfo } from 'globals/store/app.data';
import { mobileAppNotificationsReselector } from '../mobile-store/mobile.app.reselector';
import { MobileAppSubpage } from '../mobile-store/mobile.data';
import { SmallButtonComponent } from '../../buttons/small-button.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-app-notifications',
    template: `
<div class="notification" *ngFor="let not of notifications; first as first" [class.first]="first">
  <div class="text"><span class="title">{{ not.title }}</span> {{ not.message }}</div>
  <small-button *ngIf="not.linkType" (click)="openNotificationLink(not)">Click</small-button>
</div>
<div style="flex:1;"></div>
`,
    styleUrls: ['./mobile-app-notifications.scss'],
    standalone: true,
    imports: [SmallButtonComponent, CommonModule]
})
export class MobileAppNotificationsComponent extends MobileAppWrapper<MobileAppNotificationsComponent> implements OnInit {
  ngOnInit() {}
  appInfo: JoiAppInfo
  notifications: AppNotification[]
  subPages: MobileAppSubpage[] = ['notifications']
  dottedSubPages: Set<MobileAppSubpage> = new Set(['notifications'])

  constructor() {
    super()
    this.selectProp(mobileAppNotificationsReselector, null, 'notifications')
  }

  openNotificationLink(not: AppNotification) {
    this.mobileAppService.openNotificationLink(not)
  }
}

